import {
    collection,
    getVariantByParentType,
    globalCounterPath,
    parentTypeFor,
    readGlobalCount,
} from "../_variants/index.js";

import { pad } from "../../../utils";

export const addEAR = ({ form, pageItem, store, meta }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? pageItem?.ParentType);
    const earCollection = collection(variant, "EARs");
    const earCollectionTail = parentTypeFor(variant, "EARs");
    const counterPath = globalCounterPath(variant, "counts/ears/count");

    const nextNumber = readGlobalCount(store, variant, ["ears"]);
    const number = `${variant.docPrefix}EAR-${pad(nextNumber)}`;

    form.setConfig({
        "title": "Add EAR",
        "type": "push",
        "location": `${earCollection}/`,
        "fields": [{
            "label": "EAR Number",
            "type": "value",
            value() {
                return number;
             }
        }, {
            "label": "Title",
            "name": "Title",
            "type": "text"
        }],
        async preSubmitHook({ db }) {
            const claimed = await db.utils.allocateCount(counterPath);
            const number = `${variant.docPrefix}EAR-${pad(claimed)}`;
            return {
                "Cancelled": false,
                "CreatedBy": store.getters.userName,
                "ParentID": pageItem.ID,
                "ParentType": meta.ParentType,
                "Parent": pageItem.Number,
                "Date": {
                    "Created": new Date().toISOString(),
                    "Cancelled": "N/A",
                    "Signedoff": "N/A"
                },
                "Revision": 1,
                "RevisionID": "---R1",
                "Revisions": {
                    "---R1": {
                        "Revision": 1,
                        "Reason": "EADT Created",
                        "ID": "---R1",
                        "Date": new Date().toISOString()
                    }
                },
                "Number": number,
            };
        },
        async postSubmitHook({ newData, db }) {
            await db.set(`Database/${meta.ParentType}/${pageItem.ID}/${earCollectionTail}/${newData.ID}`, true);
        }
    });
    form.toggle();
}

export const editEAR = ({ form, item  }) => {
    const variant = getVariantByParentType(item?.ParentType ?? item?.ParentType);
    const earCollection = collection(variant, "EARs");

    form.setValues(item)
    form.setConfig({
        "title": "Edit EAR",
        "type": "update",
        "location": `${earCollection}/${item.ID}`,
        "fields": [{
            "label": "Title",
            "name": "Title",
            "type": "text"
        }]
    });
    form.toggle();
}



export const revisionRollback = ({ form, item, db, meta, pageItem, toast }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? item?.ParentType ?? pageItem?.ParentType);
    const earCollection = collection(variant, "EARs");

    //order the revisions by date from oldest to newest
    let revisions = Object.values(item.Revisions).sort((a, b) => {
        return new Date(a.Date) - new Date(b.Date);
    });

    let previousRevision = revisions[revisions.length - 2];

    if (!previousRevision) {
        toast.warn("No previous revision found");
        return;
    }

    // check the links and roll back any links
    let links = Object.fromEntries(
        Object
            .entries(item.Links)
            .filter(([key, value]) => {
                return value === item.RevisionID;
            }).map(([key, value]) => {
                return [`Links/${key}`, previousRevision.ID];
            })
    );

    form.setConfig({
        "title": "Rollback Revision",
        "description": `Rollback revision from ${item.Revision} to ${previousRevision.Revision}.`,
        "type": "update",
        "location": `${earCollection}/${item.ID}`,
        "fields": [],
        preSubmitHook() {
            return {
                [`Revisions/${item.RevisionID}`]: null,
                "RevisionID": previousRevision.ID,
                "Revision": previousRevision.Revision,
                ...links
            }
        }
    });
    form.toggle();
};
